<template>
  <v-container fluid>
    <v-card flat>
      <Form
        v-if="isWordListReady"
        ref="formRef"
        v-slot="{ meta, errors, validate }"
        :validate-on-mount="true"
        keep-values
       
      >
        <v-card flat>
          <v-card-title v-if="mode === 0" class="mb-3 text-h5 font-weight-bold">
            {{ wordList.lbl_fixtures_register }}
          </v-card-title>

          <v-card-title
            v-else-if="mode === 1"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_fixtures_register }}確認
          </v-card-title>

          <v-card-title
            v-else-if="mode === 2"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_fixtures_register }}完了
          </v-card-title>

          <v-card-text v-if="mode !== 2">
            <v-card flat class="pl-5 pt-3">
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_fixtures_kind_quantity }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <div
                    v-for="(value, index) in fixturesItems"
                    :key="index"
                    class="fixtures-row"
                    :class="{
                      'fixtures-row-error': errors[value?.fixtures_name ?? ''],
                    }"
                  >
                    <v-row dense>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center"
                          dense
                          justify="end"
                          style="
                            vertical-align: middle;
                            margin-top: 8px;
                            padding-right: 10px;
                          "
                        >
                          {{ value?.fixtures_name ?? "" }}
                        </v-row>
                      </v-col>
                      <v-col
                        v-if="mode === 0"
                        cols="2"
                        class="font-weight-black"
                      >
                        <Field
                          v-slot="{ field, errors }"
                          :name="value?.fixtures_name ?? ''"
                          rules="required"
                          :initial-value="value?.fixtures_quantity ?? '-'"
                        >
                          <v-autocomplete
                            :model-value="field.value ?? value?.fixtures_quantity"
                            :items="unitItems"
                            :no-data-text="wordList.lbl_no_data_text"
                            :error-messages="errors"
                            density="compact"
                            variant="outlined"
                            return-object
                            style="width: 90%"
                            @update:model-value="
                              (val) => {
                                field.onChange(val);
                                if (value !== null && value !== undefined) {
                                  value.fixtures_quantity = val;
                                }
                              }
                            "
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                      <v-col
                        v-else-if="mode === 1"
                        cols="1"
                        class="font-weight-black"
                      >
                        <v-row align="center"
                          dense
                          style="vertical-align: middle; margin-top: 8px"
                          justify="end"
                        >
                          {{ value?.fixtures_quantity ?? "-" }}
                        </v-row>
                      </v-col>
                      <v-col cols="4" class="font-weight-black">
                        <v-row
                          dense
                          style="vertical-align: middle; margin-top: 8px"
                        >
                          {{ value?.fixtures_unit_name ?? "" }}</v-row
                        ></v-col
                      >
                    </v-row>
                  </div>
                  <div v-if="mode === 0" style="color: #696969; padding: 5px">
                    {{ wordList.lbl_fixtures_worning_message }}
                  </div>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_other_memo }}
                  </v-row>
                </v-col>
                <v-col v-if="mode === 0" cols="6" sm="6" md="6" lg="6">
                  <Field v-slot="{ errors }" :name="wordList.lbl_other_memo">
                    <v-textarea
                      v-model="order_note"
                      variant="outlined"
                      :error-messages="errors"
                    >
                    </v-textarea>
                    <div style="color: #696969; padding: 5px">
                      <span>{{ wordList.lbl_fixtures_memo_message_01 }}</span
                      ><br />
                      <span>{{ wordList.lbl_fixtures_memo_message_02 }}</span>
                    </div>
                  </Field>
                </v-col>
                <v-col
                  v-else-if="mode === 1"
                  cols="6"
                  sm="6"
                  md="6"
                  lg="6"
                  style="min-height: 200px"
                >
                  <span style="white-space: pre-wrap">{{ order_note }}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions v-if="mode === 0" class="justify-center flex-wrap">
            <v-btn
              variant="flat"
              color="primary"
              class="px-16"
              :disabled="!meta.valid"
              @click="onClickOpenConfirm"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <span>{{ wordList.btn_regist_confirm }}</span>
            </v-btn>
          </v-card-actions>
          <v-card-actions
            v-else-if="mode === 1"
            class="justify-center flex-wrap"
          >
            <v-btn
              variant="flat"
              color="return"
              class="btn_width_1 my-2 mx-2"
              @click="
                () => {
                  onClickConfirmCancel();
                  validate();
                }
              "
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <v-btn
              variant="flat"
              color="primary"
              class="btn_width_1 my-2 mx-2"
              @click="onClickCompleted"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              {{ wordList.btn_regist_complete }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card-text v-if="mode === 2">
          <div style="min-height: 500px">
            <span class="text_16px">
              <strong
                >資材発注の登録が完了しました。<br />
                折り返しの連絡または資材の到着をお待ちください。</strong
              >
            </span>
          </div>
          <v-card-actions class="justify-center flex-wrap">
            <v-btn
              variant="flat"
              color="return"
              class="btn_width_1 my-2 mx-2"
              @click="onClickBackToStart"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </Form>
    </v-card>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
      :show-title="false"
    />
  </v-container>
</template>

<script setup lang="ts">
import { Form, Field } from "vee-validate";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import { useFixturesRegisterActions } from "./composables/useFixturesRegisterActions";
import { useFixturesRegisterApi } from "./composables/useFixturesRegisterApi";
import { useFixturesRegisterInit } from "./composables/useFixturesRegisterInit";
import { useFixturesRegisterState } from "./composables/useFixturesRegisterState";
import { useFixturesRegisterValidation } from "./composables/useFixturesRegisterValidation";

useFixturesRegisterValidation();

const {
  errdialog,
  errMessage,
  mode,
  formRef,
  wordList,
  order_note,
  unitItems,
  fixturesItems,
  fixturesOrderInput,
  isWordListReady,
} = useFixturesRegisterState();

const { fetchWordList, fetchFixtures, createFixturesOrder } = useFixturesRegisterApi();

useFixturesRegisterInit({
  wordList,
  fixturesItems,
  unitItems,
  formRef,
  fetchWordList,
  fetchFixtures,
});

const {
  onClickOpenConfirm,
  onClickConfirmCancel,
  onClickCompleted,
  onClickBackToStart,
} = useFixturesRegisterActions({
  mode,
  errdialog,
  errMessage,
  order_note,
  fixturesItems,
  fixturesOrderInput,
  formRef,
  createFixturesOrder,
});
</script>

<style scoped>
.fixtures-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 58px;
  margin-top: 10px;
}
.fixtures-row-error {
  height: auto;
}
</style>
